import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  getPlacementStatusList,
  PlacementStatusDTO,
  getPlacementStage,
  savePlacementStage,
  PlacementStage,
} from 'wisestep-api';
import { Label, WsButton, WsSelect, WsTypography, WsTypoVariants } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { placementSettingsIndexOptions } from '../helper/ClosureHelper';

const defaultValues = {
  revokedStatusId: '',
  offerAcceptedStatusId: '',
  joinedStatusId: '',
};

export const PlacementStageForm = () => {
  const form = useForm<PlacementStage>({ defaultValues });
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [placementStatusList, setPlacementStatusList] = useState<PlacementStatusDTO[]>([]);

  useEffect(() => {
    (async () => {
      const response = await getPlacementStatusList();
      setPlacementStatusList(response.data);
    })();
    (async () => {
      const response = await getPlacementStage();
      form.reset(response.data);
    })();
  }, [form]);

  return (
    <SettingsPageLayout
      title="Placement Stage"
      indexOptions={placementSettingsIndexOptions}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.PLACEMENTS,
        Pages['PLACEMENT_STAGE']
      )}
    >
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(async (data) => {
            if (
              data.joinedStatusId === data.revokedStatusId ||
              data.revokedStatusId === data.offerAcceptedStatusId ||
              data.offerAcceptedStatusId === data.joinedStatusId
            ) {
              setNotification(
                warning(`Placement status cannot be allocated to multiple placement stages!`)
              );
            } else {
              try {
                const response = await savePlacementStage(data);
                form.reset(response.data);
                setNotification(success('Placement Stage updated successfully!'));
              } catch (error) {
                setNotification(failed('Something Went Wrong , Please try again!'));
              }
            }
          })}
        >
          <Grid px={8} py={4}>
            <Grid item justifyContent="flex-end" display="flex">
              <WsButton size="large" type="submit">
                Save
              </WsButton>
            </Grid>
            <Grid container item xs={12} pt={2}>
              <Grid item xs={3}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE}>Placement Stage</WsTypography>
              </Grid>
              <Grid item xs={3}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE}>Placement Status</WsTypography>
              </Grid>
              <Grid item xs={6} />
            </Grid>
            <Grid container item xs={12} rowSpacing={4} pt={6}>
              {[
                { stage: 'Offer Accepted', name: 'offerAcceptedStatusId' },
                { stage: 'Joined', name: 'joinedStatusId' },
                { stage: 'Revoked', name: 'revokedStatusId' },
              ].map((item) => (
                <>
                  <Grid item xs={3}>
                    <Label sx={{ fontWeight: 'bold' }}>{item.stage}</Label>
                  </Grid>
                  <Grid item xs={3}>
                    <WsSelect
                      required
                      name={item.name}
                      selectArray={placementStatusList.map(({ placementStatusName, id }) => ({
                        label: placementStatusName,
                        value: id,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={6} />
                </>
              ))}
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </SettingsPageLayout>
  );
};
